import React, { useState, useEffect, useMemo } from "react";
import { Row, Col, Card, Spinner } from "react-bootstrap";
import { useCookies } from "react-cookie";
import { getConfigOrganization } from "ServerAPI/serverAPI";
import { useLocation } from "react-router-dom";
import Department from "./Department";
import Process from "./Domain";
import Users from "./Users";
import CommonHeader from "layouts/dashboard/CommonHeader";
import organisationIcon from "../../assets/images/Organisation.svg";

const ConfigOrg = () => {
  const [displayType, setDisplayType] = useState("department");
  const [cookies] = useCookies();
  const [orgName, setOrgName] = useState("");
  const [allDepartments, setAllDepartments] = useState([]);
  const [allProcessess, setAllProcessess] = useState([]);
  const [loadingOrganizationDetails, setLoadingOrganizationDetails] =
    useState(false);
  const [organizationDetails, setOrganizationDetails] = useState({});
  const location = useLocation();

  // const overlayStyle = {
  //   display: "flex",
  //   justifyContent: "center",
  //   alignItems: "center",
  //   height: "100vh",
  //   width: "100vw",
  //   position: "fixed",
  //   top: 0,
  //   left: 0,
  //   backgroundColor: "rgba(0, 0, 0, 0.5)",
  //   zIndex: 1000,
  // };

  const activeTabStyle = useMemo(
    () => ({
      backgroundColor: "white",
      color: "rgba(34, 75, 153, 1)",
      fontWeight: "bold",
    }),
    []
  );

  // const Spinner = () => (
  //   <div style={overlayStyle}>
  //     <div
  //       style={{
  //         animation: "spin 1s linear infinite",
  //         borderRadius: "50%",
  //         height: "10rem",
  //         width: "10rem",
  //         borderTop: "2px solid #224b99",
  //         borderBottom: "2px solid #224b99",
  //       }}
  //     ></div>
  //   </div>
  // );

  const fetchOrganisationDetails = async () => {
    try {
      setLoadingOrganizationDetails(true);
      const details = await getConfigOrganization(
        cookies?.email,
        cookies?.organizationId,
        cookies?.userId
      );

      if (details?.status === 200) {
        setOrganizationDetails(details.data);
        setOrgName(details?.data?.name);
        setAllProcessess(details?.data?.domain);
        setAllDepartments(details?.data?.department);
      } else {
        console.error("Failed to fetch organization details:", details);
      }
    } catch (error) {
      console.error("Error fetching organization details:", error);
    } finally {
      setLoadingOrganizationDetails(false);
    }
  };

  useEffect(() => {
    fetchOrganisationDetails();
  }, []);

  useEffect(() => {
    if (location.state?.showProgramCordinatorTab) setDisplayType("users");
  }, [location]);

  return (
    <>
      <CommonHeader
        text={orgName || ""}
        subText="Manage your organization here"
        icon={organisationIcon}
      />
      <div className="d-flex justify-content-center">
        <div
          className="mt-5 mx-20"
          style={{
            width: "100%",
          }}
        >
          <Card>
            <Card.Body>
              <ul className="nav nav-tab w-100 d-flex align-items-center mb-4">
                <li className="nav-item bg-light p-1">
                  <button
                    className={`nav-link rounded ${displayType === "department" ? "font-bold" : "text-secondary"}`}
                    style={displayType === "department" ? activeTabStyle : {}}
                    onClick={() => setDisplayType("department")}
                  >
                    Department
                  </button>
                </li>
                <li className="nav-item bg-light p-1">
                  <button
                    className={`nav-link rounded ${displayType === "process" ? "font-bold" : "text-secondary"}`}
                    style={displayType === "process" ? activeTabStyle : {}}
                    onClick={() => setDisplayType("process")}
                  >
                    Domain
                  </button>
                </li>
                <li className="nav-item bg-light p-1">
                  <button
                    className={`nav-link rounded ${displayType === "users" ? "font-bold" : "text-secondary"}`}
                    style={displayType === "users" ? activeTabStyle : {}}
                    onClick={() => setDisplayType("users")}
                  >
                    Users
                  </button>
                </li>
              </ul>
              {loadingOrganizationDetails ? (
                <div className="text-center p-4">
                  <Spinner animation="border" />
                </div>
              ) : (
                <>
                  {displayType === "department" && (
                    <Department
                      allDepartments={allDepartments}
                      setAllDepartments={setAllDepartments}
                      allProcessess={allProcessess}
                      fetchOrganisationDetails={fetchOrganisationDetails}
                    />
                  )}
                  {displayType === "process" && (
                    <Process
                      allProcessess={allProcessess}
                      setAllProcessess={setAllProcessess}
                      allDepartments={allDepartments}
                      fetchOrganisationDetails={fetchOrganisationDetails}
                    />
                  )}
                  {displayType === "users" && (
                    <Users
                      allDepartments={allDepartments}
                      organizationDetails={organizationDetails}
                    />
                  )}
                </>
              )}
            </Card.Body>
          </Card>
        </div>
      </div>
    </>
  );
};

export default ConfigOrg;
